import { useQuery } from "@tanstack/react-query";

import { ServiceRequestDetails } from "../../types/service.type";

import { getServiceRequestById } from "../services/goHireService";
import { GO_SERVICE_QUERY_KEYS } from "../queryKeys";

export const useGetServiceRequest = (requestId: number) => {
  return useQuery<ServiceRequestDetails>({
    queryKey: [...GO_SERVICE_QUERY_KEYS.serviceRequest(requestId), { requestId: requestId }],
    queryFn: async () => getServiceRequestById(requestId),
    enabled: !!requestId,
  });
};
